import { PRICING_CARDS } from '@Web/Pages/Web/Pricing/constants.js';
import SectionHeader from '@Web/Src/Components/SectionHeader';
import Card from '@Web/Src/Components/Card';

const PlanCards = ({ className = '' }) => {
    return (
        <>
            <SectionHeader
                type='dark'
                className={`${className} mx-auto mt-24`}
                icon='credit-card-refresh'
                title={__('What every plan gets you: ')}
                desc={__('')}
            />

            <div
                className={
                    'small:gap-5 mx-auto mt-16 flex w-full max-w-4xl flex-wrap justify-center gap-12'
                }
            >
                {PRICING_CARDS.map((item, index) => {
                    return (
                        <Card
                            data={item}
                            key={index}
                            sprite={'pricing-icons-sprite'}
                            iconSize={'!size-8 sasas'}
                        />
                    );
                })}
            </div>
        </>
    );
};

export default PlanCards;
